import { createContext, useRef } from "react";

export const ViewInventoryVehicleModalContext = createContext({});

const ViewInventoryVehicleModalProvider = ({ children }) => {
  // Make an array of refs to store the reference of the action icons
  const openActionRef = useRef([]);
  return (
    <ViewInventoryVehicleModalContext.Provider
      value={{
        openActionRef,
      }}
    >
      {children}
    </ViewInventoryVehicleModalContext.Provider>
  );
};

export default ViewInventoryVehicleModalProvider;
